'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { useState } from 'react';
import '@common/utils/serialisation/luxonDateTime';
import superjson from 'superjson';
import { AppRouter } from 'trpc/routers/_app';
import { getQueryClient } from '../env/getQueryClient';
import { getUrl } from './getUrl';

export const trpc = createTRPCReact<AppRouter>();

export function TRPCProvider(
  props: Readonly<{
    children: React.ReactNode;
    queryClient?: ReturnType<typeof getQueryClient>;
  }>,
) {
  // NOTE: Avoid useState when initializing the query client if you don't
  //       have a suspense boundary between this and the code that may
  //       suspend because React will throw away the client on the initial
  //       render if it suspends and there is no boundary
  const queryClient = props.queryClient ? props.queryClient : getQueryClient();

  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          transformer: superjson,
          url: getUrl(),
          maxURLLength: 2083, // We have to limit this, or else next doesn't let the batch through and we have to retry
        }),
      ],
    }),
  );
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    </trpc.Provider>
  );
}
